import type { FlowThemeCardMotion } from '../../cardMotion';

/** The card unfolds from a crease along its left edge and folds back along it. */
export const origamiCardMotion = (): FlowThemeCardMotion => ({
  variants: {
    enter: () => ({ opacity: 0, rotateY: -64 }),
    center: { opacity: 1, rotateY: 0 },
    exit: () => ({ opacity: 0, rotateY: 64 }),
  },
  transition: { duration: 0.75, ease: [0.22, 1, 0.36, 1] },
  style: { transformPerspective: 1200, transformOrigin: '0% 50%' },
});
